import React, { useState } from 'react';
import { timelineData } from '../data/sections';

const InteractiveTimeline = () => {
  const [activeTimelineItem, setActiveTimelineItem] = useState(0);

  return (
    <div className="space-y-6">
      <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
        <div className="w-3 h-3 bg-blue-600 rounded-full animate-pulse"></div>
        My Journey
      </h3>
      {timelineData.map((item, index) => (
        <div
          key={index}
          className={`relative flex items-start gap-4 p-4 rounded-lg cursor-pointer transition-all duration-300 transform hover:scale-105 ${
            activeTimelineItem === index 
              ? 'bg-gradient-to-r from-blue-50 to-purple-50 shadow-lg' 
              : 'hover:bg-gray-50'
          }`}
          onClick={() => setActiveTimelineItem(index)}
        >
          <div className={`relative flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center text-2xl transition-all duration-300 ${
            activeTimelineItem === index ? 'scale-110 shadow-lg' : ''
          }`}
          style={{ 
            backgroundColor: item.color === 'blue' ? '#dbeafe' : 
                           item.color === 'green' ? '#dcfce7' :
                           item.color === 'yellow' ? '#fef3c7' :
                           item.color === 'purple' ? '#f3e8ff' : '#fee2e2'
          }}>
            {item.icon}
            {activeTimelineItem === index && (
              <div className="absolute -top-1 -right-1 w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>
            )}
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-sm font-bold text-blue-600 bg-blue-100 px-2 py-1 rounded">
                {item.year}
              </span>
              {activeTimelineItem === index && (
                <div className="flex gap-1">
                  <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
                  <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                  <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                </div>
              )}
            </div>
            <h4 className="font-semibold text-lg text-gray-800">{item.title}</h4>
            <p className={`text-gray-600 transition-all duration-300 ${
              activeTimelineItem === index ? 'text-base' : 'text-sm'
            }`}>
              {item.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InteractiveTimeline;